import { TranslationVehiclesModuleMessages, VehiclesModuleMessages } from "../interfaces";

export const messages: TranslationVehiclesModuleMessages = {
  // region Backend messages

  // region Vehicle-events messages
  [VehiclesModuleMessages.updateVehicleEventSuccess]: "Event updated successfully",
  [VehiclesModuleMessages.eventNotFound]: "Event not registered in our system",
  [VehiclesModuleMessages.updateVehicleEventError]: "Failed to update event",
  [VehiclesModuleMessages.readVehicleEventSuccess]: "Event(s) returned successfully",
  [VehiclesModuleMessages.noVehicleEventFound]: "No event registered for the trip in question",
  [VehiclesModuleMessages.readVehicleEventError]: "Failed to search event(s)",
  // endregion
  // region Vehicles-states messages
  [VehiclesModuleMessages.createVehicleStateSuccess]: "Vehicle state registered successfully",
  [VehiclesModuleMessages.createVehicleStateError]: "Failed to register vehicle state",
  [VehiclesModuleMessages.readVehicleStateSuccess]: "Vehicle state(s) returned successfully",
  [VehiclesModuleMessages.noVehicleStateFound]: "No vehicle state registered",
  [VehiclesModuleMessages.readVehicleStateError]: "Failed to fetch vehicle state(s)",
  [VehiclesModuleMessages.noVehicleStateInTravelFound]: "No vehicle state registered for the trip in question",
  [VehiclesModuleMessages.getVehiclesAndTravelsError]: "Failed to fetch vehicles and travels information",
  [VehiclesModuleMessages.getVehiclesHardwaresError]: "Failed to fetch vehicles hardwares information",
  [VehiclesModuleMessages.getVehiclesAlertsError]: "Failed to fetch vehicles alerts information",
  [VehiclesModuleMessages.getMixerTravelsSpecificInfoError]: "Failed to fetch mixer travels specific information",
  [VehiclesModuleMessages.getPumpTravelsSpecificInfoError]: "Failed to fetch pump travels specific information",
  [VehiclesModuleMessages.getAggregateTruckTravelsSpecificInfoError]: "Failed to fetch aggregate truck travels specific information",
  [VehiclesModuleMessages.noVehicleStateInVehicleFound]: "No vehicle state registered for the vehicle ",
  // endregion
  // region Vehicle-states-types messages
  [VehiclesModuleMessages.readVehicleStateTypeSuccess]: "Vehicle state type(s) returned successfully",
  [VehiclesModuleMessages.noVehicleStateTypeFound]: "No vehicle state type registered",
  [VehiclesModuleMessages.readVehicleStateTypeError]: "Failed to fetch vehicle state type(s)",
  // endregion
  // region Vehicle-types messages
  [VehiclesModuleMessages.readVehicleTypeSuccess]: "Vehicle type(s) returned successfully",
  [VehiclesModuleMessages.noVehicleTypeFound]: "No vehicle type registered",
  [VehiclesModuleMessages.readVehicleTypeError]: "Failed to fetch vehicle type(s)",
  // endregion
  // region Vehicles messages
  [VehiclesModuleMessages.createVehicleSuccess]: "Vehicle registered successfully",
  [VehiclesModuleMessages.createVehicleError]: "Failed to register vehicle",
  [VehiclesModuleMessages.readVehicleSuccess]: "Vehicle(s) returned successfully",
  [VehiclesModuleMessages.noVehicleFound]: "No vehicle found",
  [VehiclesModuleMessages.readVehicleError]: "Failed to fetch vehicle(s)",
  [VehiclesModuleMessages.updateVehicleSuccess]: "Vehicle updated successfully",
  [VehiclesModuleMessages.vehicleNotFound]: "Vehicle not registered in our system",
  [VehiclesModuleMessages.updateVehicleError]: "Failed to update vehicle",
  [VehiclesModuleMessages.deleteVehicleSuccess]: "Vehicle deleted successfully",
  [VehiclesModuleMessages.onlyInactivateVehicleMessage]: "Vehicle with more than one state cannot be deleted, only inactivated",
  [VehiclesModuleMessages.deleteVehicleError]: "Failed to delete vehicle",
  [VehiclesModuleMessages.code]: "Code",
  [VehiclesModuleMessages.licensePlate]: "License plate",
  [VehiclesModuleMessages.invalidUserOrPassword]: "Invalid user or password",
  [VehiclesModuleMessages.userNotAuthorizedToBlockVehicle]: "User not authorized to block vehicle",
  [VehiclesModuleMessages.vehicleWithoutHardware]: "Vehicle does not have hardware",
  [VehiclesModuleMessages.vehicleWithoutBlockCapableHardware]: "Vehicle does not have hardware capable of blocking",
  [VehiclesModuleMessages.blockRequestSent]: "Block requested successfully",
  [VehiclesModuleMessages.unblockRequestSent]: "Unblock requested successfully",
  [VehiclesModuleMessages.blockRequestError]: "Failed to request block/unblock",
  [VehiclesModuleMessages.getVehicleInfoSuccess]: "Vehicle info returned successfully",
  [VehiclesModuleMessages.getVehicleInfoError]: "Failed to fetch vehicle info",
  [VehiclesModuleMessages.updateVehicleConfigSuccess]: "Vehicle configuration updated successfully",
  [VehiclesModuleMessages.updateVehicleConfigError]: "Failed to update vehicle configuration",
  [VehiclesModuleMessages.batchUpdateMaxSpeedSuccess]: "Maximum speed updated successfully",
  [VehiclesModuleMessages.batchUpdateMaxSpeedError]: "Failed to update vehicles maximum speed",
  [VehiclesModuleMessages.general]: "General",
  [VehiclesModuleMessages.concreteMixers]: "Concrete mixers",
  [VehiclesModuleMessages.pumpTrucks]: "Pumps",
  [VehiclesModuleMessages.supportVehicles]: "Support",
  [VehiclesModuleMessages.total]: "Total",
  [VehiclesModuleMessages.average]: "Average",

  // region Vehicle types
  [VehiclesModuleMessages.concreteMixer]: "Concrete mixer",
  [VehiclesModuleMessages.concreteMixers]: "Concrete mixers",
  [VehiclesModuleMessages.pumpTruck]: "Pump truck",
  [VehiclesModuleMessages.pumpTrucks]: "Pump trucks",
  [VehiclesModuleMessages.supportVehicle]: "Support vehicle",
  [VehiclesModuleMessages.loaders]: "Loaders",
  [VehiclesModuleMessages.loader]: "Loader",
  [VehiclesModuleMessages.aggregateTrucks]: "Aggregate trucks",
  [VehiclesModuleMessages.aggregateTruck]: "Aggregate truck",
  [VehiclesModuleMessages.siloTrucks]: "Silo trucks",
  [VehiclesModuleMessages.siloTruck]: "Silo truck",
  // endregion

  // endregion
  // region Integration messages
  [VehiclesModuleMessages.locationNotRegistered]: "Location(s) not registered",
  [VehiclesModuleMessages.driverNotRegistered]: "Driver(s) not registered",
  [VehiclesModuleMessages.externalIDAlreadyRegistered]: "External ID(s) already registered",
  [VehiclesModuleMessages.licensePlateAlreadyRegistered]: "License plate(s) already registered",
  [VehiclesModuleMessages.codeAlreadyRegistered]: "Code(s) already registered",
  [VehiclesModuleMessages.invalidDateFormat]: "Invalid date format",
  [VehiclesModuleMessages.noDataForThisVehicleOrDay]: "No data for this vehicle and/or day",
  [VehiclesModuleMessages.readVehicleDailySummarySuccess]: "Vehicle(s) daily summary returned successfully",
  [VehiclesModuleMessages.vehicleWithoutTracker]: "Vehicle doesn't have a linked tracker",
  [VehiclesModuleMessages.invalidTrackerReadingsRange]: "Invalid period. Inform start_date and finish_date, at most 1 day apart",
  [VehiclesModuleMessages.invalidVehicleHistoryDateRange]: "Invalid date range. Maximum allowed: 60 days",
  [VehiclesModuleMessages.readTrackerReadingsSuccess]: "Tracker readings returned successfully",
  // endregion

  // endregion
  // region Frontend messages

  // region General
  [VehiclesModuleMessages.description]: "Description",
  [VehiclesModuleMessages.status]: "Status",
  [VehiclesModuleMessages.odometer]: "Odometer",
  [VehiclesModuleMessages.odometerInKm]: "Odometer (km)",
  [VehiclesModuleMessages.hourMeter]: "Hour meter",
  [VehiclesModuleMessages.hourMeterInHours]: "Hour meter (h)",
  [VehiclesModuleMessages.maintenance]: "Maintenance",
  [VehiclesModuleMessages.originalAllocation]: "Original allocation",
  [VehiclesModuleMessages.currentAllocation]: "Current allocation",
  [VehiclesModuleMessages.currentEvent]: "Current event",
  [VehiclesModuleMessages.searchingVehicles]: "Searching vehicles...",
  [VehiclesModuleMessages.vehicleDeleteConfirmation]: "Are you sure you want to delete the vehicle",
  [VehiclesModuleMessages.vehicleRegistration]: "Vehicle registration",
  [VehiclesModuleMessages.activeVehicle]: "Active vehicle",
  [VehiclesModuleMessages.active]: "Active",
  [VehiclesModuleMessages.inactive]: "Inactive",
  [VehiclesModuleMessages.vehicleUnderMaintenance]: "Vehicle under maintenance",
  [VehiclesModuleMessages.vehicleType]: "Vehicle type",
  [VehiclesModuleMessages.maxSpeedAllowed]: "Max speed allowed",
  [VehiclesModuleMessages.maxSpeedAllowedTooltip]: "The speed alert will be triggered considering a variation of up to 5% above the configured value.",
  [VehiclesModuleMessages.allocationPlant]: "Allocation plant",
  [VehiclesModuleMessages.defaultDriver]: "Default driver",
  [VehiclesModuleMessages.title]: "Vehicles",
  [VehiclesModuleMessages.deleteDialogTitle]: "Delete confirmation",
  [VehiclesModuleMessages.vehicles]: "Vehicles",
  [VehiclesModuleMessages.blocks]: "Blocks",
  [VehiclesModuleMessages.group]: "Group",
  [VehiclesModuleMessages.regional]: "Regional",
  [VehiclesModuleMessages.plant]: "Plant",
  [VehiclesModuleMessages.lastCommunicationDate]: "Last communication date",
  [VehiclesModuleMessages.lastCommunication]: "Last communication",
  [VehiclesModuleMessages.ignition]: "Ignition",
  [VehiclesModuleMessages.lastIgnitionDate]: "Last ignition",
  [VehiclesModuleMessages.lastPlantExitDate]: "Last plant exit",
  [VehiclesModuleMessages.currentLatitude]: "Current latitude",
  [VehiclesModuleMessages.currentLongitude]: "Current longitude",
  [VehiclesModuleMessages.currentAddress]: "Current address",
  [VehiclesModuleMessages.activeHardware]: "Active GPS",
  [VehiclesModuleMessages.analyticReport]: "Analytic report",
  [VehiclesModuleMessages.batchChangeMaxSpeed]: "Batch change max speed",
  [VehiclesModuleMessages.batchChangeMaxSpeedDialogTitle]: "Change maximum speed",
  [VehiclesModuleMessages.batchChangeMaxSpeedConfirmation]: "Are you sure you want to change the maximum speed of the selected vehicles?",
  [VehiclesModuleMessages.batchChangeMaxSpeedCancelSelection]: "Cancel selection",
  [VehiclesModuleMessages.batchChangeMaxSpeedVehiclesList]: "Vehicles to be updated:",
  // endregion General
  // region Vehicle Config
  [VehiclesModuleMessages.vehicleCANParameters]: "Vehicle CAN parameters",
  [VehiclesModuleMessages.fuelTankSize]: "Fuel tank capacity (L)",
  [VehiclesModuleMessages.fuelTankSizeEstimated]: "Automatically estimated capacity (L)",
  [VehiclesModuleMessages.fuelTankSizeEstimatedAt]: "estimated on",
  [VehiclesModuleMessages.fuelTankSizeEstimatedTooltip]: "Calculated from the vehicle's consumption calibration. If a capacity is provided above, the provided value prevails and this one remains as reference.",
  [VehiclesModuleMessages.resetFuelTankEstimate]: "Recalculate estimate",
  [VehiclesModuleMessages.resetFuelTankEstimateConfirm]: "This clears the current estimate and the calibration learning — the system will estimate again from scratch over the next days of operation. Continue?",
  [VehiclesModuleMessages.resetFuelTankEstimateSuccess]: "Fuel tank capacity estimate successfully reset",
  [VehiclesModuleMessages.resetFuelTankEstimateError]: "Error resetting the fuel tank capacity estimate",
  [VehiclesModuleMessages.maxTemperatureLimit]: "Maximum temperature limit (°C)",
  [VehiclesModuleMessages.harshAccelerationThreshold]: "Harsh acceleration threshold (m/s²)",
  [VehiclesModuleMessages.harshBrakingThreshold]: "Harsh braking threshold (m/s²)",
  [VehiclesModuleMessages.harshCorneringThreshold]: "Harsh cornering threshold (m/s²)",
  [VehiclesModuleMessages.maxRpmLimit]: "Maximum RPM limit",
  [VehiclesModuleMessages.vehicleCANParametersUpdateSuccess]: "Vehicle CAN parameters updated successfully",
  [VehiclesModuleMessages.vehicleCANParametersLoadError]: "Failed to load vehicle CAN parameters",
  // endregion
  // region Water Factor Control
  [VehiclesModuleMessages.waterFactorControlTitle]: "Water factor control",
  [VehiclesModuleMessages.waterFactorControlTab]: "Control",
  [VehiclesModuleMessages.waterFactorHistoryTab]: "History",
  [VehiclesModuleMessages.vehicleWithoutHardwareTooltip]: "Vehicle does not have hardware linked to it",
  [VehiclesModuleMessages.controlTabExplanatoryText]: "To initiate the calibration procedure, click the start analysis button and after the start "
    + "add a precisely known quantity of water to the vehicle. Next, interrupt the analysis on the system, allocating the quantity in the informed "
    + "field and press the calculate and save button.\n\n"
    + "The system will use the data collected during this period to calculate the new correction factor (or calibration factor), "
    + "which will be displayed on the screen as the final result of the process.",
  [VehiclesModuleMessages.controlTabHardwareBrand]: "Brand",
  [VehiclesModuleMessages.controlTabHardwareModel]: "Model",
  [VehiclesModuleMessages.controlTabHardwareDevId]: "Device ID",
  [VehiclesModuleMessages.controlTabAnalysisPeriod]: "Analysis period",
  [VehiclesModuleMessages.controlTabStartAnalysis]: "Start analysis",
  [VehiclesModuleMessages.controlTabStopAnalysis]: "Stop analysis",
  [VehiclesModuleMessages.controlTabResetAnalysis]: "Reset analysis",
  [VehiclesModuleMessages.controlTabAmountOfWater]: "Amount of water",
  [VehiclesModuleMessages.controlTabCalculateButton]: "Calculate and save",
  [VehiclesModuleMessages.controlTabHardwareOffline]: "The vehicle's hardware has been offline for more than 30 minutes. "
    + "It is not possible to start the analysis.",
  [VehiclesModuleMessages.waterFactorResultTitle]: "Calculation Successfully Concluded!",
  [VehiclesModuleMessages.waterFactorResultPreviousFactor]: "Previous Factor:",
  [VehiclesModuleMessages.waterFactorResultHardwareWater]: "Water (Hardware):",
  [VehiclesModuleMessages.waterFactorResultUserWater]: "Water (User):",
  [VehiclesModuleMessages.waterFactorResultNewCalibration]: "Perform new calibration",
  [VehiclesModuleMessages.waterFactorSourceIntelligentSuggestion]: "Intelligent suggestion",
  [VehiclesModuleMessages.waterFactorSourceManual]: "Manual",
  [VehiclesModuleMessages.waterFactorSourceRevert]: "Revert",
  [VehiclesModuleMessages.historyTabCurrentWaterFactor]: "Water factor",
  [VehiclesModuleMessages.historyTabPreviousWaterFactor]: "Previous water factor",
  [VehiclesModuleMessages.historyTabSourcedFrom]: "Source",
  [VehiclesModuleMessages.historyTabChangedByUser]: "Changed by",
  [VehiclesModuleMessages.historyTabChangedDate]: "Changed date",
  [VehiclesModuleMessages.historyTabStatus]: "Status",
  [VehiclesModuleMessages.historyTabActions]: "Actions",
  [VehiclesModuleMessages.historyTabActiveText]: "Active",
  [VehiclesModuleMessages.historyTabTooltipActiveText]: "This water factor is currently active",
  [VehiclesModuleMessages.historyTabRevertButton]: "Revert"
  // endregion Water Factor Control

  // endregion
};
